/* assets/cylinder-configurator.js */
(function () {
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (e) => {
    const root =
      document.querySelector(`.section-${e.detail.sectionId}-padding[data-section-id="${e.detail.sectionId}"]`) ||
      document.querySelector(`[data-section-id="${e.detail.sectionId}"]`);
    if (root && root.classList.contains('cyl-config')) initSection(root);
  });

  function initAll() {
    document.querySelectorAll('.cyl-config').forEach(initSection);
  }

  function initSection(root) {
    const sectionId = root.getAttribute('data-section-id');
    const productBox = root.querySelector('.cyl-config__card');
    if (!productBox) return;

    /* ===== Modal ===== */
    const dlg = root.querySelector(`#dlg-${sectionId}`);
    const trigger = root.querySelector('.cyl-info-trigger');
    const closeBtn = root.querySelector('.cyl-modal__close');
    let lastFocused = null;

    if (trigger && dlg) {
      trigger.addEventListener('click', () => {
        lastFocused = document.activeElement;
        if (dlg.showModal) dlg.showModal(); else dlg.show();
        (dlg.querySelector('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])') || dlg).focus();
      });
    }
    if (closeBtn && dlg) {
      const close = () => { if (dlg.open) { dlg.close('close'); if (lastFocused && lastFocused.focus) lastFocused.focus(); } };
      closeBtn.addEventListener('click', (e) => { e.preventDefault(); close(); });
      dlg.addEventListener('click', (e) => {
        const card = dlg.querySelector('.cyl-modal__card');
        if (card && !card.contains(e.target)) close();
      });
    }

    /* ===== Variant data ===== */
    const productJSON = productBox.getAttribute('data-product-json');
    if (!productJSON) return;
    const product = JSON.parse(productJSON);
    const variants = product.variants || []; // option1/2/3 structure. :contentReference[oaicite:1]{index=1}

    /* ===== UI refs ===== */
    const form = root.querySelector('#cylAddForm');
    const idInput = form && form.querySelector('input[name="id"]');
    const qtyInp  = form && root.querySelector('.cyl-qtyinp');

    const groups  = root.querySelectorAll('.cyl-pills');
    const skuEl   = root.querySelector('.cyl-sku');
    const priceEl = root.querySelector('.cyl-price-current');
    const compEl  = root.querySelector('.cyl-price-compare');
    const variantLabel = root.querySelector('#cylVariantLabel');
    const ctaBtn  = root.querySelector('.cyl-cta');

    /* ===== Money ===== */
    window.theme = window.theme || {};
    window.theme.moneyFormat = window.theme.moneyFormat || window.SHOP_MONEY_FORMAT || "${{amount}}";
    const moneyFormat = window.theme.moneyFormat;

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      try {
        const currency = document.documentElement.getAttribute('data-shop-currency') || 'EUR';
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((+cents || 0) / 100);
      } catch (e) {
        return ((+cents || 0) / 100).toFixed(2);
      }
    }
    // Shopify beveelt cent-waarden + format aan voor consistente weergave. :contentReference[oaicite:2]{index=2}

    /* ===== Variant helpers ===== */
    function selectedOptions() {
      return Array.from(groups).map(g => {
        const s = g.querySelector('.cyl-pill.is-selected');
        return s ? s.dataset.value : '';
      });
    }
    function findVariantByOptions(opts) {
      return variants.find(v => opts.every((val, idx) => v['option' + (idx + 1)] === val));
    }
    function applyVariant(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (skuEl) skuEl.textContent = v.sku || '';
      if (variantLabel) variantLabel.textContent = v.title;

      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compEl.style.display = '';
          compEl.textContent = formatMoney(v.compare_at_price);
        } else {
          compEl.style.display = 'none';
          compEl.textContent = '';
        }
      }
      if (ctaBtn) ctaBtn.disabled = !v.available;

      // variant deep-link
      const url = new URL(window.location);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }
    function initPillsFromCurrent() {
      const current = product.selected_or_first_available_variant || variants.find(v => v.available) || variants[0];
      const parts = [current.option1, current.option2, current.option3].filter(Boolean);

      groups.forEach((g, idx) => {
        const btn = Array.from(g.children).find(b => b.dataset.value === (parts[idx] || ''));
        if (btn) {
          g.querySelectorAll('.cyl-pill').forEach(b => b.classList.remove('is-selected'));
          btn.classList.add('is-selected');
        }
      });

      if (priceEl && priceEl.hasAttribute('data-cents')) priceEl.textContent = formatMoney(+priceEl.dataset.cents || current.price);
      if (compEl && compEl.hasAttribute('data-cents')) {
        const cents = compEl.dataset.cents ? +compEl.dataset.cents : current.compare_at_price;
        if (cents && cents > (priceEl.dataset.cents ? +priceEl.dataset.cents : current.price)) {
          compEl.style.display = '';
          compEl.textContent = formatMoney(cents);
        } else {
          compEl.style.display = 'none';
          compEl.textContent = '';
        }
      }
      applyVariant(current);
    }

    /* ===== NEW: combinaties verbergen (in plaats van disablen) ===== */
    function getCurrentOptionValues() {
      return Array.from(root.querySelectorAll('.cyl-pills')).map(g => {
        const sel = g.querySelector('.cyl-pill.is-selected');
        return sel ? sel.dataset.value : '';
      });
    }
    function existsVariantMatching(partialOpts) {
      // "Bestaat de combinatie?" — voorraad-onafhankelijk
      return variants.some(v =>
        partialOpts.every((val, idx) => !val || v['option' + (idx + 1)] === val)
      );
    }
    function updateAvailability() {
      const current = getCurrentOptionValues();
      const groupsLocal = root.querySelectorAll('.cyl-pills');

      groupsLocal.forEach((group, optIndex) => {
        let keepSelected = false;

        group.querySelectorAll('.cyl-pill').forEach(btn => {
          const probe = current.slice();
          probe[optIndex] = btn.dataset.value;

          const possible = existsVariantMatching(probe);

          // Verberg onmogelijke waarden
          btn.classList.toggle('is-disabled', !possible);

          if (possible && btn.classList.contains('is-selected')) keepSelected = true;
        });

        // Als de huidige keuze binnen deze groep niet meer geldig is, auto-selecteer eerste geldige
        if (!keepSelected) {
          const firstPossible = Array.from(group.querySelectorAll('.cyl-pill')).find(b => b.style.display !== 'none');
          group.querySelectorAll('.cyl-pill').forEach(b => b.classList.remove('is-selected'));
          if (firstPossible) {
            firstPossible.classList.add('is-selected');
          }
        }
      });

      // Na herselecteren (indien gebeurd) de variant opnieuw toepassen
      const v = findVariantByOptions(selectedOptions());
      if (v) applyVariant(v);
    }

    /* ===== Bindings ===== */
    groups.forEach(group => {
      group.addEventListener('click', (e) => {
        const btn = e.target.closest('.cyl-pill');
        if (btn.classList.contains('is-disabled')) return; // onzichtbare opties zijn niet klikbaar

        group.querySelectorAll('.cyl-pill').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        const v = findVariantByOptions(selectedOptions());
        if (v) applyVariant(v);

        updateAvailability();
      });
    });

    // qty
    if (qtyInp) {
      const clamp = v => { v = parseInt(v || '1', 10); return (Number.isFinite(v) && v > 0) ? v : 1; };
      root.querySelectorAll('.cyl-qtybtn').forEach(btn => {
        btn.addEventListener('click', () => { qtyInp.value = clamp((+qtyInp.value || 1) + (btn.dataset.qty === '+1' ? 1 : -1)); });
      });
      qtyInp.addEventListener('input', () => { qtyInp.value = qtyInp.value.replace(/[^\d]/g, ''); });
      qtyInp.addEventListener('change', () => { qtyInp.value = clamp(qtyInp.value); });
    }

    /* ===== Init ===== */
    initPillsFromCurrent();
    updateAvailability(); // verberg niet-geldige combinaties bij start
  }
})();
